import { AppApolloClient } from '@/interfaces/graphql';
import { IoCContainer } from '@/ioc/framework/container';

import { RepositoryModule } from './repositories';
import { ServiceModule } from './services';

export function setupModules(container: IoCContainer, client: AppApolloClient): void {
  const repositoryModule = new RepositoryModule();
  const serviceModule = new ServiceModule();
  repositoryModule.onCreate(container, client);
  serviceModule.onCreate(container);
}
